<template>
    <div>
        <button @click="project.createConnection()">Draw</button>
        {{mode}}
        <br>
        <input id="selector" v-model="mode" type="radio" :value="Project.MODE_DEFAULT">
        <label for="selector">Selector</label>
        <br>
        <input id="node" v-model="mode" type="radio" :value="Project.MODE_RECTANGLE">
        <label for="node">Node</label>
        <br>
        <input id="connection" v-model="mode" type="radio" :value="Project.MODE_CONNECTION">
        <label for="connection">Connection</label>
    </div>
</template>

<script>
    import Project from './project';

    export default {
        name: "ToolManager",

        props: [
            'project'
        ],

        data: function () {
            return {
                Project,
                mode: null,
                node: null,
                tools: {}
            };
        },

        watch: {
            mode: function (mode) {
                this.tools[mode].activate();
                this.project.setMode(mode);
            }
        },

        mounted: function () {
            this.tools[Project.MODE_DEFAULT] = new paper.Tool();
            this.tools[Project.MODE_RECTANGLE] = this.initRectangleTool();
            this.tools[Project.MODE_CONNECTION] = this.initConnectionTool();

            this.tools[Project.MODE_DEFAULT].activate();
        },

        methods: {
            initRectangleTool: function () {
                let paperToolRectangle = new paper.Tool();

                paperToolRectangle.onMouseDown = (e) => {
                    this.node = this.project.createNode([e.point.x, e.point.y]);
                };

                paperToolRectangle.onMouseDrag = (e) => {
                    this.node.setSize([e.delta.x, e.delta.y]);
                };

                paperToolRectangle.onMouseUp = (e) => {
                    if (!e.modifiers.control) {
                        this.mode = Project.MODE_DEFAULT;
                    }
                };

                paperToolRectangle.onKeyUp = (e) => {
                    if (e.key === 'control') {
                        this.mode = Project.MODE_DEFAULT;
                    }
                };

                return paperToolRectangle;
            },

            initConnectionTool: function () {
                let paperToolConnection = new paper.Tool();

                paperToolConnection.onMouseDown = (e) => {
                    this.node = this.project.createConnection([e.point.x, e.point.y]);
                };

                paperToolConnection.onMouseDrag = (e) => {
                    this.node.moveDestination(e.point.x, e.point.y);
                };

                paperToolConnection.onMouseUp = (e) => {
                    if (!e.modifiers.control) {
                        this.mode = Project.MODE_DEFAULT;
                    }
                };

                paperToolConnection.onKeyUp = (e) => {
                    if (e.key === 'control') {
                        this.mode = Project.MODE_DEFAULT;
                    }
                };

                return paperToolConnection;
            },
        }
    }
</script>
